import { PromptParametersProps } from "./types";
import { observer } from "mobx-react-lite";
import { ModelPreviewContent } from "./ModelPreviewContent";

export const ParametersPreviewContent = observer(
  ({
    titleClassName,
    showLearnMore = true,
    showGeneralInformation = true,
  }: Omit<PromptParametersProps, "displayAsPopover" | "promptData">) => (
    <div className="flex w-full flex-col gap-3">
      <div className="flex items-center justify-between">
        <h4 className={`text-base font-medium leading-none ${titleClassName}`}>
          {showGeneralInformation ? "Parameters" : "Model Information"}
        </h4>
        {showLearnMore && (
          <a
            className="text-xs text-blue-500 hover:text-blue-400"
            target="_blank"
            rel="noreferrer"
            href="https://docs.promptlayer.com/features/prompt-registry#metadata-2"
          >
            Learn more
          </a>
        )}
      </div>
      <ModelPreviewContent showGeneralInformation={showGeneralInformation} />
    </div>
  ),
);
